var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['button-main', _vm.buttonWhite && 'white'],attrs:{"type":_vm.type}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }